import classNames from "classnames";
import {useState} from "react";
import {FiArrowRight} from "react-icons/fi";

import {Button} from "@/components/button/Button.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {SkipOnboardingModal} from "@/pages/onboardingwizard/components/skiponboardingmodal/SkipOnboardingModal.tsx";
import {SubmitProps} from "@/pages/onboardingwizard/components/step/Step.tsx";

import styles from "./SkipButton.module.scss";

interface SkipButtonProps extends SubmitProps {
  activeStepNr: number;
}

export const SkipButton = ({onSubmit, stepsCount, activeStepNr}: SkipButtonProps) => {
  const [showSkipModal, setShowSkipModal] = useState<boolean>(false);
  const isFirstStep = activeStepNr === 0;

  return (
    <>
      <div className={classNames(styles.skipButton, {[styles.mobileFullWidth]: isFirstStep})}>
        <Button variant="secondary" size="large" onClick={() => setShowSkipModal(true)}>
          Skip Onboarding <Icon icon={FiArrowRight} />
        </Button>
      </div>
      {showSkipModal && (
        <SkipOnboardingModal
          onSubmit={() => {
            onSubmit(stepsCount, false);
          }}
          showSkipModal={showSkipModal}
          setShowSkipModal={setShowSkipModal}
        />
      )}
    </>
  );
};
